import React, { useState , useEffect } from "react";
import { useParams } from "react-router-dom";
import './Details.css'
import { useSelector } from 'react-redux'

function Details() {

    const [data, setData] = useState([]);

    const params = useParams()


    

    // const data = useSelector(state => state.productReducer)


    // const { product } = data


  

    const  fetchData = async() => {
      await fetch('/productsdata.json')
        .then((res) => 
          res.json())
            .then((data) => 
            setData(data.productdata))
    }
  
  
  
    useEffect(() => {
      fetchData()
      
    },[])
// console.log(params.id,params.model);
   
const details = data.find((i) => i.id == params.id)

console.log(details);



  return (

   <>
        
    
        {details ? (
            <div className="main">


<section className="section-content padding-y bg">
        <div className="container">
    
        <article className="single">
            <div className="single-body">
                    <div className="row">
                        <aside className="col-md-6">
                                <article className="gallery-wrap">
                                    <div className="single img-big-wrap">
                                        <a href="#"> <img className="image" src={details.image} /></a>
                                    </div> 

                                </article>
                        </aside>
                        <main className="col-md-6 details">


                        <div className="cartbutton">
                        <a href="#" className="text-primary btn-link">{details.category}</a>


</div>
                            <article className="mainarea">
                                
                                <h3 className="title" style={{ color:"red" }}>{details.model}</h3>
								<dt className="col-sm-3 mt-3">Brand : <span className="brand">{details.brand}</span>&nbsp; &nbsp; Storage : <span className="storage">{details.storage}</span></dt>
	
                                
        
                                <div className=" last d-flex mt-4">
                                    <h2 className="price"><span className="rs" style={{ fontSize: "40px" }}>Rs.</span> {details.price}</h2> <br />
                               

							    </div> 
                                <hr />


                    
                                <div className="mb-3">


									
                                    <dl className="row">

									<dt className="col-sm-3">B Version</dt>
                              <dd className="col-sm-9">{details.bversion}</dd>


                              <dt className="col-sm-3 ">Display</dt>
                              <dd className="col-sm-9">{details.display}</dd>

							  <dt className="col-sm-3">Type</dt>
                              <dd className="col-sm-9">{details.type}</dd>
        
                              <dt className="col-sm-3">Processor</dt>
                              <dd className="col-sm-9">{details.processor}</dd>
        
                              <dt className="col-sm-3">Camera</dt>
                              <dd className="col-sm-9">{details.camera}</dd>
        
                              <dt className="col-sm-3">Memory</dt>
                              <dd className="col-sm-9">{details.ram}{details.memory}</dd>
                              
                              <dt className="col-sm-3">Graphics</dt>
                              <dd className="col-sm-9">{details.graphics}</dd>

							  <dt className="col-sm-3">Warranty</dt>
                              <dd className="col-sm-9">{details.warranty} Year</dd>

							  <dt className="col-sm-3">Battery</dt>
                              <dd className="col-sm-9">{details.battery}</dd>


                        </dl>
                                </div>
                                <hr />
                                
        
                                
                                
                            </article> 
                        </main>
                    </div> 
            </div> 
        </article>

        </div>
        
    
    </section>
            </div>
        ): 'null'}

       </>
  )
}

export default Details